import React from 'react';
import {Maybe} from 'monet';
import querystring from 'querystring';
import {Table} from 'reactstrap';
import {mapWithIndex, present} from '@/util';
import Icon from '@/views/shared/Icon';
import DownloadFileButton from '@/views/shared/DownloadFileButton';
import {useProducerCtx} from '@/views/Layout/b2b/ProducerNavBar/state';
import {useTranslation} from 'react-i18next';

const Download = ({company, path}) => (
  <span>
    {company}
    <DownloadFileButton className='btn btn-link px-1' path={path}>
      <span>
        <Icon icon='file-pdf' />
      </span>
    </DownloadFileButton>
  </span>
);

const StatementItem = ({item: {month, regionCode, pdfList}}) => {
  const [producer] = useProducerCtx();
  const pdfs = mapWithIndex((stmt, idx) => {
    const path = `/b2b/commissions/download_statement?${querystring.stringify({
      month,
      code: stmt.producerCode,
      company: stmt.companyName,
      region: regionCode,
      producerId: producer.producerId,
      fileType: stmt.fileType,
    })}`;

    return (
      <span key={`download_${month}_${idx}`}>
        <Download company={stmt.fileName} path={path} />
        {idx < pdfList.length - 1 && ' / '}
      </span>
    );
  })(pdfList);

  return Maybe.fromFalsy(present(pdfList))
    .map(() => pdfs)
    .orElse('N/A');
};

const StatementList = ({items}) => {
  const {t: tr} = useTranslation('commission');
  const itemList = mapWithIndex((item, idx) => (
    <tr key={`stmt_${idx}`}>
      <td>{item.month}</td>
      <td>
        <StatementItem item={item} />
      </td>
    </tr>
  ))(items);

  return (
    <Table striped bordered responsive className='mt-4'>
      <thead>
        <tr>
          <th>{tr('issue_month')}</th>
          <th>{tr('pdf_version')}</th>
        </tr>
      </thead>
      <tbody>{itemList}</tbody>
    </Table>
  );
};

export default StatementList;
